module.exports = __webpack_public_path__ + "static/media/verticalDots.3e515480.svg";